// extracted by mini-css-extract-plugin
export default {"header":"styles_header__8kgkp","alt":"styles_alt__YSlAi"};